import React, { useState } from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { IOnlineDirectories } from "../types";
import { editStateOnlineDirectories } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";

export const OnlineDirectoriesDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IOnlineDirectories | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateOnlineDirectories);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks
  const [brandNameInput, setBrandNameInput] = useState(data?.brandName || "");
  const [brandDescriptionInput, setBrandDescriptionInput] = useState(
    data?.description || ""
  );
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white shadow-lg h-full">
          <div className="grid grid-cols-6 mx-3 pb-2 gap-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="brandName"
                label="Brand Name"
                type="text"
                onChange={(e) => {
                  setBrandNameInput(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    brandDescriptionInput.trim() === "" ||
                    (e.target.value === data?.brandName &&
                      brandDescriptionInput.trim() === data?.description &&
                      checkBoxChanges == data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.brandName &&
                  formMethods.formState.errors.brandName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("brandName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="description"
                label="Description"
                type="text"
                onChange={(e) => {
                  setBrandDescriptionInput(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    brandNameInput.trim() === "" ||
                    (e.target.value === data?.description &&
                      brandNameInput.trim() === data?.brandName &&
                      checkBoxChanges == data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.description &&
                  formMethods.formState.errors.description.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("description", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            {edit && (
              <div className="my-1 mx-2">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);

                    if (
                      brandNameInput?.trim() === "" ||
                      brandDescriptionInput?.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        brandNameInput == data?.brandName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OnlineDirectoriesDetails;
